import Toggle from './classes/toggle';
import Swiper, {Scrollbar, Mousewheel} from 'swiper/core';

Swiper.use([Scrollbar, Mousewheel]);

function InitSlider() {
	if (window.innerWidth < 1024) return;

	const images = document.querySelectorAll('.swiper-container img');

	setTimeout(() => {
		images.forEach((image) => {
			const actualHeight = image.height;
			const imageWidth = Number(image.getAttribute('width'));
			const imageHeight = Number(image.getAttribute('height'));

			image.setAttribute('width', String(actualHeight * imageWidth / imageHeight));
		});
	}, 50);

	setTimeout(() => {
		// Initialize swiper
		const swiper = new Swiper('.swiper-container', {
			freeMode: true,
			slidesPerView: 'auto',
			mousewheel: {
				sensitivity: 1.5,
			},
			followFinger: false,
			spaceBetween: 30,
			scrollbar: {
				el: '.swiper-scrollbar',
				draggable: true,
			}
		});
	}, 450);
}

function InitProjectModals() {
	const projectModalContainer = document.querySelector('.project-modal');
	const projectModalClose = document.querySelector('.project-modal-close');
	const projectLinks = document.querySelectorAll('.cover[data-project]');

	if (projectLinks.length === 0) return;

	projectModalContainer.style.display = 'none';
	projectModalContainer.style.opacity = '0';

	projectLinks.forEach((projectLinks) => {
		const project = projectLinks.dataset.project;

		projectLinks.addEventListener('click', (event) => {
			event.preventDefault();

			const projectModalContent = projectModalContainer.querySelector(`[data-project="${project}"]`);
			if (projectModalContent === null) return;

			projectModalContent.style.display = 'block';
			projectModalContainer.style.pointerEvents = 'auto';
			show(projectModalContainer);

			projectModalClose.addEventListener('click', () => {
				hide(projectModalContainer);

				setTimeout(() => {
					projectModalContent.style.display = 'none';
					projectModalContainer.style.pointerEvents = 'none';
				}, 300);
			}, {once: true});
		});
	});
}

function InitMobileNav() {
	const documentBody = document.querySelector('body');
	const mobileNavigation = document.querySelector('.mobile-nav');

	const buttonOpen = new Toggle(document.querySelector('button.mobile-nav-open'), (event) => {
		if (buttonOpen.state === 'true') {
			show(mobileNavigation);
			documentBody.classList.add('locked');
		} else {
			hide(mobileNavigation);
			documentBody.classList.remove('locked');
		}
	});
}

function InitCoverText() {
	if (window.innerWidth < 1024) return;
	const projectLinks = document.querySelectorAll('.cover[data-project]');

	projectLinks.forEach((projectLink) => {
		const coverText = projectLink.querySelector('.cover-text');
		if (coverText === null) return;

		projectLink.addEventListener('mousemove', (event) => {
			coverText.style.top = event.clientY - projectLink.getBoundingClientRect().top + 'px';
			coverText.style.left = event.clientX - projectLink.getBoundingClientRect().left + 'px';
		});
	});
}

function show(element) {
	// Show section
	element.style.display = 'block';

	// Cancel the race condition for a smooth animation
	setTimeout(() => {
		element.style.opacity = '1';
	}, 0);
}

function hide(element) {
	// Hide section
	element.style.opacity = '0';

	setTimeout(() => {
		element.style.display = 'none';
	}, 300);
}

const siteInitialization = () => {
	InitSlider();

	// Initialize project modals
	InitProjectModals();

	InitMobileNav();
	InitCoverText();
};

// Run the init function as soon as the DOM tree has been loaded
if (document.readyState !== 'loading') siteInitialization();
else document.addEventListener('DOMContentLoaded', siteInitialization);
